export default __webpack_public_path__ + "static/finance-2d8e82b6f84a651de3ad526f4cb0a13f.png";